import { firebaseEtiquetasRepository } from '../../infrastructure/etiquetas/firebaseEtiqueta.repository'

export const addEtiqueta = etiquetas => {
  etiquetas.map(async etiqueta => {
    const tag = await firebaseEtiquetasRepository.obtenerEtiqueta(etiqueta)
    if (!tag.exists) {
      firebaseEtiquetasRepository.guardarNuevaEtiqueta(etiqueta)
    }
  })
}
